export default {
    tip: '如未查询到用户请点击右侧新增按钮',
    no_selected: '您还未选中作者',
    batch_live_title: '批量设置直播备注',
    batch_live_note_warning: '注意：三项都不选择，则更新会议下所有 session 的直播备注 !!!',
    batch_live_label_date: '日期',
    batch_live_label_hall: '会场',
    batch_live_label_xuezu: '专题分论坛',
    batch_live_label_live_notes: '直播备注',
    title: '标题',
    batch_modify: '批量修改',
    session_name: 'Session 名称',
    time_period: '时段',
    batch_edit: '批量编辑',
    no_select_not_update: '不选择表示不做更新',
    cn_website_display_mode: '中文网站显示方式',
    en_website_display_mode: '英文网站显示方式',
    edit_unit: '编辑单元',
    meeting_schedule_management: '会议日程管理',
    export_session: '导出 Session 日程',
    topic_forum: '所属专题分论坛：',
    delete_session: '确认删除【{session}】该 Session 吗？',
    meeting_session_management: '会议日程管理',
    edit_session: '编辑 Session',
    add_chair_host_translator_chinese: '添加主席/主持/翻译（中宾）',
    add_chair_host_translator_foreign: '添加主席/主持/翻译（外宾）',
    host: '主持',
    chinese_guest: '中宾',
    foreign_guest: '外宾',
    view_conflict: '查看冲突',
    translator: '翻译',
    time_linkage_checkbox: '当前条结束时间小于下一条的开始时间时，后面的时间段是否联动',
    add_topic_speaker_chinese: '添加讲题讲者（中宾）',
    add_topic_speaker_foreign: '添加讲题讲者（外宾）',
    add_discussion_etc: '添加讨论/辩论/其他',
    start_time_placeholder: '开始时间',
    end_time_placeholder: '结束时间',
    add_host_chinese: '添加主持（中宾）',
    add_host_foreign: '添加主持（外宾）',
    upload_video: '上传视频',
    edit: '编 辑',
    batch_save: '批量保存',
    sorting: '排序',
    start_time: '开始时间',
    end_time: '结束时间',
    duration_minutes: '时长（分钟）',
    type: '类型',
    task_allocation: '任务分配',
    question: '题目',
    modify_topic_forum: '修改专题分论坛',
    add_topic_forum: '添加专题分论坛',
    cn_name: '中文名称',
    en_name: '英文名称',
    meeting_date: '会议日期',
    current_date_color: '当前日期的日程颜色',
    schedule_color: '日程颜色',
    export_program: '导出日程',
    select_export_date: '选择导出日期',
    select_export_hall: '选择导出会场',
    select_export_special_forum: '选择导出专题分论坛',
    show_host_unit: '是否显示主持人单位',
    show_speaker_unit: '是否显示发言人单位',
    show_speech_type: '是否显示发言类型',
    show_country: '是否显示国别',
    show_chinese_english: '是否显示中英文',
    show_all: '全部展示',
    show_chinese_only: '只展示中文',
    show_english_only: '只展示英文',
    show_paper_number: '是否显示论文编号',
    show_paper_number_text: '显示论文编号',
    show_serial_number: '显示序号',
    show_hidden_schedule: '是否显示隐藏日程',
    export_program_word: '导出日程 Word 版',
    export_program_excel: '导出日程 Excel 版',
    update_hall: '修改会场',
    add_hall: '添加会场',
    hall_cn_name_placeholder: '请填写会场中文名称',
    hall_en_name_placeholder: '请填写会场英文名称',
    hall_login_account: '会场登录账号（幻灯系统Online版）',
    hall_login_account_placeholder: '请填写会场登录账号',
    hall_login_password: '会场登录密码（幻灯系统Online版）',
    hall_login_password_placeholder: '请填写会场登录密码',
    hall_ad_open: '是否开启场外广告',
    hall_computer_ip: '会场电脑ip',
    hall_computer_ip_placeholder: '请填写会场电脑ip',
    hall_sorting_placeholder: '请填写排序',
    hall_remarks_placeholder: '请填写备注',
    program_logs_title: '学术日程更新日志',
    query_start_date: '查询开始日期',
    start_date_placeholder: '开始日期',
    query_end_date: '查询截止日期',
    end_date_placeholder: '结束日期',
    table_column_id: '编号',
    table_column_notice: '更新说明',
    table_column_create_time: '更新时间',
    table_column_name: '操作人',
    repeat_list_drawer_title: '日程自动查重',
    repeat_list_drawer_date_conflict_title: '日程时间冲突',
    repeat_list_drawer_fayan_conflict_title: '同一篇论文多次发言',
    repeat_list_drawer_edit_unit: '单元编辑',
    task: '任务',
    theme: '主题',
    abstract_id: '论文ID',
    unit: '单元',
    modify_task: '修改任务',
    basic_info: '基本信息',
    participation_form: '参会形式',
    recorded_broadcast: '录播',
    online_connection: '线上连线',
    on_site_participation: '现场参会',
    topic_speaker_info: '讲题讲者信息',
    query_author: '查询作者',
    service_fee: '劳务费',
    has_service_fee: '是否有劳务费',
    currency: '币种',
    service_fee_amount: '劳务费金额',
    please_fill_service_fee_amount: '请填写劳务费金额',
    role_task: '角色任务',
    person_in_charge: '负责人',
    add_academic_unit: '添加学术单元',
    single_schedule_duration: '单条日程时长(分钟）',
    change_single_schedule_duration: '是否变更单条日程时长',
    unit_chinese_title: '单元中文标题',
    unit_english_title: '单元英文标题',
    session_introduction_cn: 'session简介中文',
    session_introduction_en: 'session简介英文',
    unit_color: '单元颜色',
    is_satellite_tip: '开启后可在直播页面专题会tab展示',
    is_sync_program_tip: '关闭后不同步到幻灯系统',
    live_source_tip: '控制日程页面观看直播按钮的显示',
    default_hall_config: '默认会场配置：调用会场关联的直播',
    system_table_live: '系统表直播：选择关联调用系统直播',
    third_party_live: '第三方平台直播：填写第三方平台链接调用跳转第三方平台地址',
    select_associated_live: '选择关联直播',
    session_label: 'Session标签',
    session_label_tip: '用于在PC和移动端日程Session标题后显示',
    session_contact: 'Session负责人',
    session_contact_tel: 'Session负责人电话',
    satellite_display_image: '专题会展示图片',
    satellite_display_image_tip: '建议尺寸950*150px ，支持JPG,GIF,PNG图片文件,文件大小：≤500kb',
    satellite_display_image_usage: '用于直播页卫星会tab展示',
    satellite_company_logo: '专题会企业Logo',
    upload_image: '上传图片',
    label_xuezu: '分论坛',
    unplanned_list_drawer_title: '已评审未排进日程文章',
    batch_remove: '批量删除',
    real_name: '作者',
    typename_cn: '录用类型',
    unplanned_members_drawer_title: '查看未安排学术任务委员名单',
    select_branch: '选择分会',
    please_select: '请选择',
    click_to_view: '点击查看',
    keyword: '关键字',
    name_phone_email: '姓名/手机号/邮箱',
    task_allocation_label: '任务安排',
    arranged: '已安排',
    unarranged: '未安排',
    search: '查询',
    committee_task_allocation: '委员任务安排：已安排',
    people: '人 ，未安排',
    export_unplanned_members_list: '导出未安排学术任务委员名单',
    user_id: '用户ID',
    position: '任职',
    please_select_branch: '请先选择分会',
    name: '姓名',
    organization: '单位',
    title_search: '标题',
    speech_type: '发言类型',
    search_button: '查询',
    date_label: '日期',
    add_date_button: '添加日期',
    all_option: '全部',
    hall_label: '会场',
    add_hall_button: '添加会场',
    special_forum_label: '专题分论坛',
    add_special_forum_button: '添加专题分论坛',
    hall_date_header: '会场/日期',
    quick_switch_hall: '快速切换会场',
    add_academic_unit_button: '添加学术单元',
    edit_date_modal: '编辑日期弹窗',
    edit_special_forum_modal: '编辑专题分论坛弹窗',
    edit_hall_modal: '编辑会场坛弹窗',
    repeat_list_drawer: '日程时间冲突查重',
    child_session_drawer: '子session',
    edit_session_drawer: '编辑日程',
    unplanned_list_drawer: '已评审未排进日程文章',
    export_program_modal: '导出日程',
    program_logs_drawer: '查看日程更新记录',
    batch_live_modal: '批量设置直播备注',
    batch_session_drawer: '批量修改Session信息',
    unplanned_members_drawer: '查看未安排学术任务委员名单',
    upload_video_drawer: '视频上传管理',
    all_units: '全部单元',
    add_unit: '添加单元',
    view_program_cn: '查看日程(中文页面)',
    view_program_en: '查看日程(英文页面)',
    clear_cache: '清空日程缓存',
    more_operations: '更多操作',
    sort_success: '排序成功',
    back_to_schedule_list: '返回日程一览',
    view_session: '查看该Session',
    role: '角色',
    sorting_tip: '序号越小越靠前',
    hall_type: '会场类型',
    chinese_hall: '中文会场',
    english_hall: '英文会场',
    is_satellite: '是否是专题会',
    is_sync_program: '是否同步到现场日程',
    live_source: '直播来源',
    abstract_type: '可选论文类别',
    forum_info: '分论坛信息',

    add_title_tips: '注意：请直接搜索稿件标题，未查询到再新增',
    p_duration_minutes: '请输入时长（分钟）',
    meeting_type: '会议形式',
    p_meeting_type: '请选择会议形式',
    meeting_type1: '录播',
    meeting_type2: '线上连接',
    meeting_type3: '现场参会',
    meeting_type4: '未确定',
    p_has_service_fee: '请选择是否有劳务费',
    p_currency: '请选择币种',
    add_title_search: '标题/ID搜索',
    p_add_title_search: '请输入标题/ID进行搜索',

    // 以下为自动提取 program-config 相关页面的语言包
    speak_config_add: '新增', // 新增;
    speak_config_table: '表格', // 表格;
    drag_sort: '排序', // 排序;
    chinese_name: '中文名称', // 中文名称;
    english_name: '英文名称', // 英文名称;
    status: '状态', // 状态;
    role: '角色', // 角色;
    operation: '操作', // 操作;
    confirm_delete_category: '确定要删除该类别吗？', // 确定要删除该类别吗？;
    delete_success: '删除成功', // 删除成功;
    open: '开启', // 开启;
    close: '关闭', // 关闭;
    limit_config_id: '配置ID', // 配置ID;
    limit_period: '限制时段', // 限制时段;
    limit_roles: '限制角色', // 限制角色;
    limit_times: '限制人员添加次数', // 限制人员添加次数;
    limit_edit_times: '限制添加次数', // 限制添加次数;
    all: '全部', // 全部;
    every_day: '每天', // 每天;
    host_type: '主持类', // 主持类;
    discuss_type: '讨论类', // 讨论类;
    speaker_type: '讲者类', // 讲者类;
    host_and_discuss: '主持和讨论类', // 主持和讨论类;
    slide_admin: '幻灯管理员', // 幻灯管理员;
    slide_admin_manage: '试片室客户端管理员管理', // 试片室客户端管理员管理;
    slide_download: '幻灯客户端下载', // 幻灯客户端下载;
    click_download: '点击下载', // 点击下载;
    bold_name: '是否开启姓名字体加粗', // 是否开启姓名字体加粗;
    choose_bold_name: '请选择是否开启姓名字体加粗', // 请选择是否开启姓名字体加粗;
    font_color: '字体颜色设置', // 字体颜色设置;
    upload_image: '上传图片', // 上传图片;
    upload_cover: '请上传封面图', // 请上传封面图;
    suggest_size: '建议尺寸1280*720px ，支持JPG,PNG图片文件,图片大小最大2M', // 建议尺寸1280*720px ，支持JPG,PNG图片文件,图片大小最大2M;
    slide_background: '直播背景图', // 直播背景图;
    meeting_notice: '会场通知', // 会场通知;
    upload_file: '上传文件', // 上传文件;
    view_file: '查看', // 查看;
    please_upload_meeting_notice: '请上传会场会议通知', // 请上传会场会议通知;
    only_pps: '只能上传.pps类型文件', // 只能上传.pps类型文件;
    open_speaker_upload: '是否开启前台上传讲者PPT功能', // 是否开启前台上传讲者PPT功能;
    choose_open_speaker_upload: '请选择是否开启前台上传讲者PPT功能', // 请选择是否开启前台上传讲者PPT功能;
    file_version_type: '收集文件版本类型', // 收集文件版本类型;
    choose_file_version_type: '请选择收集文件版本类型', // 请选择收集文件版本类型;
    open_slide_audit: '是否开启专题会上传幻灯ppt审核', // 是否开启专题会上传幻灯ppt审核;
    choose_open_slide_audit: '请选择是否开启专题会上传幻灯ppt审核', // 请选择是否开启专题会上传幻灯ppt审核;
    speaker_upload_deadline: '前台上传讲者PPT截止时间', // 前台上传讲者PPT截止时间;
    choose_speaker_upload_deadline: '请选择前台上传讲者PPT截止时间', // 请选择前台上传讲者PPT截止时间;
    cut_content_cn: '截止后提示内容（中文）', // 截止后提示内容（中文）;
    cut_content_en: '截止后提示内容（英文）', // 截止后提示内容（英文）;
    live_mode: '直播模式', // 直播模式;
    choose_live_mode: '请选择直播模式', // 请选择直播模式;
    three_screen: '三连屏', // 三连屏;
    ppt: 'PPT', // PPT;
    open_cloud_record: '是否开启云录制', // 是否开启云录制;
    choose_open_cloud_record: '请选择是否开启云录制', // 请选择是否开启云录制;
    cloud_record_schedule: '云录制关联日程', // 云录制关联日程;
    choose_cloud_record_schedule: '请选择云录制关联日程', // 请选择云录制关联日程;
    cloud_record_mode: '云录制模式', // 云录制模式;
    choose_cloud_record_mode: '请选择云录制模式', // 请选择云录制模式;
    view_local_video: '查看本地录制视频列表', // 查看本地录制视频列表;
    view_cloud_video: '查看云录制视频列表', // 查看云录制视频列表;
    save: '保存', // 保存;
    local_video: '本地录制视频', // 本地录制视频;
    video_name: '视频名称', // 视频名称;
    file_size: '文件大小', // 文件大小;
    upload_time: '上传时间', // 上传时间;
    view: '查看', // 查看;
    slide_user_admin: '试片试管理员', // 试片试管理员;
    login_account: '登录账号', // 登录账号;
    please_enter_login_account: '请输入登录账号', // 请输入登录账号;
    login_password: '登录密码', // 登录密码;
    please_enter_login_password: '请输入登录密码', // 请输入登录密码;
    subscribe_record: '订阅记录', // 订阅记录;
    session_title: 'Session标题', // Session标题;
    user_name: '用户姓名', // 用户姓名;
    subscribe_time: '订阅时间', // 订阅时间;
    message_type: '消息类型', // 消息类型;
    send_content: '发送内容', // 发送内容;
    message_create_time: '消息创建时间', // 消息创建时间;
    receiver: '接收人', // 接收人;
    receiver_phone: '接收人手机号', // 接收人手机号;
    send_status: '发送状态', // 发送状态;
    send_time: '发送时间', // 发送时间;
    send_success: '发送成功', // 发送成功;
    not_sent: '未发送', // 未发送;
    send_failed: '发送失败', // 发送失败;
    show_status: '显示状态', // 显示状态;
    show: '显示', // 显示;
    hide: '隐藏', // 隐藏;
    please_choose_show_status: '请选择显示状态', // 请选择显示状态;
    please_enter_chinese_name: '请输入中文名称', // 请输入中文名称;
    please_enter_english_name: '请输入英文名称', // 请输入英文名称;
    role_type: '角色类型', // 角色类型;
    please_choose_role_type: '请选择角色类型', // 请选择角色类型;
    comment: '点评', // 点评;
    discuss: '讨论', // 讨论;
    judge: '评委', // 评委;
    guest: '嘉宾', // 嘉宾;
    host: '主持', // 主持;
    chairman: '主席', // 主席;
    translator: '翻译', // 翻译;
    speaker: '讲者', // 讲者;
    operator: '术者', // 术者;
    please_enter_limit_period: '请输入限制时段', // 请输入限制时段;
    please_choose_limit_roles: '请选择限制角色', // 请选择限制角色;
    please_enter_limit_times: '请输入限制添加次数', // 请输入限制添加次数;
    roles1: '全部',
    roles2: '主持类',
    roles3: '讨论类',
    roles4: '讲者类',
    pcProgramList1: '日程模板一',
    pcProgramList2: '日程模板二',
    choose_is_to_externally: '请选择日程是否对外显示',
    is_to_externally: '日程是否对外显示',
    program_abs_title_type: '日程论文标题必填规则',
    choose_program_abs_title_type: '请选择日程论文标题必填规则',
    chinese_required: '中文必填',
    english_required: '英文必填',
    chinese_and_english_required: '中英必填',
    chinese_and_english_only_one_required: '中英只需填一个',
    page_color_setting: '日程页面颜色设置',
    pc_program_template: 'PC端日程模板',
    pc_program_template_selection: 'PC端日程模板选择',
    pc_program_list_template_selection: 'PC端日程一览表模板选择',
    pc_speaker_list_template_selection: 'PC端讲者列表模板选择',
    mobile_program_template: '移动端日程模板',
    mobile_program_template_selection: '移动端日程模板选择',
    mobile_program_list_template_selection: '移动端日程一览表模板选择',
    mobile_speaker_list_template_selection: '移动端讲者列表模板选择',
    select_program_content_to_display: '请选择日程页面需要展示的内容',
    whether_to_display_serial_number: '是否显示编号',
    choose_whether_to_display_serial_number: '请选择是否显示编号',
    display_paper_serial_number: '显示论文编号',
    display_serial_number: '显示序号',
    do_not_display_serial_number: '不显示编号',
    program_display_order: '日程展示顺序',
    choose_program_display_order: '请选择日程展示顺序',
    display_by_hall_order: '按会场顺序展示',
    display_by_date_order: '按日期顺序展示',
    display_by_forum: '按分论坛显示',
    whether_to_display_chinese_and_english: '是否显示中英文',
    choose_whether_to_display_chinese_and_english: '请选择是否显示中英文',
    display_all: '全部显示',
    display_only_chinese: '只展示中文',
    display_only_english: '只展示英文',
    whether_to_display_english_page_local_time: '英文页面是否展示 Local Time',
    choose_whether_to_display_english_page_local_time: '请选择英文页面是否展示 Local Time',
    speaker_host_configuration: '讲者主持配置',
    speaker_host_list_display_order: '讲者主持列表显示顺序',
    choose_speaker_host_list_display_order: '请选择讲者主持配置',
    sort_by_pinyin_order: '按照姓名拼音顺序排序',
    sort_by_program_order: '按照日程出场顺序排序',
    whether_to_display_avatar: '是否显示头像',
    choose_whether_to_display_avatar: '请选择是否显示头像',
    whether_to_display_personal_introduction: '是否显示个人简介',
    choose_whether_to_display_personal_introduction: '请选择是否显示个人简介',
    whether_to_display_speaker_host_query_page_statistics: '是否显示讲者主持查询页面统计数',
    choose_whether_to_display_speaker_host_query_page_statistics: '请选择是否显示讲者主持查询页面统计数',
    whether_to_display_acceptance_state_in_backend_program_management_page: '后台日程管理页面是否显示接受状态',
    choose_whether_to_display_acceptance_state_in_backend_program_management_page: '请选择后台日程管理页面是否显示接受状态',
    whether_to_allow_experts_to_jump_to_expert_personal_center_from_conference_program_details: '是否允许会议日程详情点击专家姓名跳转到专家个人中心',
    choose_whether_to_allow_experts_to_jump_to_expert_personal_center_from_conference_program_details: '请选择是否允许会议日程详情点击专家姓名跳转到专家个人中心',
    whether_to_enable_academic_task_sheet_download: '是否开启学术任务单下载',
    choose_whether_to_enable_academic_task_sheet_download: '请选择是否开启学术任务单下载',
    whether_to_include_system_hidden_session_program_in_academic_task_confirmation_and_sms_email_reminder: '个人学术任务确认、短信邮件发送温馨提示时是否需要包含系统隐藏的SESSION日程',
    view_sms_send_recordchoose_whether_to_include_system_hidden_session_program_in_academic_task_confirmation_and_sms_email_reminder:
        '请选择个人学术任务确认、短信邮件发送温馨提示时是否需要包含系统隐藏的SESSION日程',
    session_subscription: 'Session订阅',
    view_session_subscription_record: '查看Session订阅记录',
    whether_to_session_subscription: '是否Session订阅',
    choose_whether_to_session_subscription: '请选择是否Session订阅',
    whether_to_send_reminder_sms: '是否发送提醒短信',
    choose_whether_to_send_reminder_sms: '请选择是否发送提醒短信',
    this_function_will_deduct_meeting_creator_sms_balance:
        '此功能会扣除会议创建者短信发送余额，提醒的日程必须在当前会议配置区间内，推送任务会提前生成，如需测试请在开始前时间上再加五分钟，避免里测试时间过近测试失败',
    conference_representative_session_reminder_send_time: '参会代表Session提醒发送时间',
    before_program_start: '日程开始前',
    please_enter_conference_representative_session_reminder_send_time: '请输入参会代表Session提醒发送时间',
    minutes_before_sending_reminder: '分钟前发出提醒',
    view_sms_send_record: '查看短信发送记录',
    conference_representative_session_reminder_content: '参会代表Session提醒内容',
    conference_representative_name: '参会者姓名',
    speaker_name: '讲者姓名',
    speech_title: '发言题目',
    speech_time: '发言时间',
    meeting_hall: '会场名称',
    please_choose_conference_representative_session_reminder_content: '请选择参会代表Session提醒内容',
    the_longest_character_length_of_a_single_sms_content_is_500_characters: '一次发放短信内容的最长字符数不超过500字符',
    program_subscription: '日程订阅',
    view_program_subscription_record: '查看日程订阅记录',
    whether_to_program_subscription: '是否日程订阅',
    choose_whether_to_program_subscription: '请选择是否日程订阅',
    conference_representative_program_reminder_send_time: '参会代表日程提醒发送时间',
    host_and_speaker_program_reminder: '主持人、发言人日程提醒',
    whether_to_enable_host_and_speaker_program_reminder: '是否开启主持人、发言人日程提醒',
    choose_whether_to_enable_host_and_speaker_program_reminder: '请选择是否日程订阅',
    send_sms_history: '短信发送记录',
    forum: '分论坛',
    copy: '复制',
    monolingual: '单语',
    bilingual: '双语',
    cut_content_example1: '例：本次会议线上课件收集已截止！可至会场上传：',
    cut_content_example2: '试片室地点：XX博览中心A馆XXX房间',
    cut_content_example3: '试片室工作时间：',
    cut_content_example4: '11月16日 13:00-19:00',
    cut_content_example5: '11月17日 07:15-17:30',
    cut_content_example6: '11月18日 07:30-17:30',
    cut_content_example7: '11月19日 07:30-11:00',
    view_local_video_list: '查看本地录制视频列表',
    cloud_record_unit_no: '单元否',
    cloud_record_unit_yes: '单元是',
    view_cloud_video_list: '查看云录制视频列表',
    program_name: '关联日程',
    related_video: '关联视频',
    recording_task_status: '录制任务状态',
    whether_upload_to_vod: '是否上传到点播',
    upload_success: '上传成功',
    recording: '录制中',
    all: '全部',
    not_transcoded: '未转码',
    transcoding: '转码中',
    upload_failed: '上传失败',
    sync_cloud_video_to_vod: '同步云录制视频到点播',
    number: '序号',
    add_task: {
        title: '添加任务',
        update_title: '修改任务',
        attendance_info: '参会信息',
        date: '日期',
        hall: '会场',
        session: 'Session',
        please_select_date: '请选择日期',
        please_select_hall: '请选择会场',
        please_select_session: '请选择Session',
        attending_by: '参会形式',
        please_select_attending_by: '请选择参会形式',
        live_streaming_link: '直播链接',
        please_add_user_info: '请先添加人员信息',
        honorarium_info: '劳务费信息',
        whether_to_pay: '是否有劳务费',
        yes: '是',
        no: '否',
        currency_type: '币种',
        please_select_currency_type: '请选择币种',
        service_fee_amount: '劳务费金额',
        please_input_service_fee_amount: '请输入劳务费金额',
        role_task_info: '角色任务信息',
        role_task: '角色任务',
        please_select_role_task: '请选择角色任务',
        responsible_person: '负责人信息',
        responsible: '负责人',
        remarks_admin: '备注',
        save: '保存',
        save_and_continue: '保存并继续',
        operation_success: '操作成功'
    },
    repeat_list_modal: {
        title: '重复任务列表',
        current_task: '当前任务',
        name: '姓名',
        org_cnname: '单位',
        date: '日期',
        hall: '会场',
        session: 'Session',
        task: '任务',
        abstract_title: '论文标题',
        time: '时间',
        abstract_title: '主题'
    },
    upload_related_video: {
        title: '上传视频',
        related_type: '关联方式',
        related_type_1: '新增视频',
        related_type_2: '关联视频资源库',
        video_name: '视频名称',
        video_name_required: '请输入视频名称',
        please_upload_video: '请上传视频',
        video_size_limit: '视频大小不能超过500M 支持视频格式：*.avi; *.wmv; *.mp4;*.mov; *.flv; *.mkv; *.rmvb',
        video_format: '支持视频格式：*.avi; *.wmv; *.mp4;*.mov; *.flv; *.mkv; *.rmvb',
        live_id: '关联直播',
        is_online: '是否在学习平台/直播回放显示',
        please_select: '请选择',
        click: '请点击搜索，不要轻易新增',
        author_list: '关联作者列表',
        please_select_author_list: '请选择关联作者列表',
        author_list_tip: '排序的序号数字越大越靠前',
        delete: '删除',
        cover_image: '视频封面',
        please_upload_cover_image: '请上传视频封面',
        upload_img: '上传图片',
        upload_img_tip: '建议尺寸1280*720px，支持JPG,GIF,PNG图片文件',
        sorting: '排序',
        sorting_tip: '排序越大越靠前',
        intro: '视频简介',
        related_video: '关联视频',
        video_is_display: '是否在日程中显示',
        authorization_state: '视频授权：',
        authorization_state_live: '直播授权：',
        cancel_related_video: '取消关联视频',
        save: '保存',
        user_id: '用户ID',
        author_name: '作者名称',
        author_org: '作者单位',
        action: '操作',
        save_success: '保存成功',
        limit_number: '文件大小不能超过500MB!',
        upload_type: '请上传后缀为{type}的格式',
        agree: '同意',
        refuse: '拒绝',
        un_confirm: '未确认',
        confirm_cancel: '确定要取消关联视频吗？',
        cancel_success: '取消成功'
    },
    batch_add_program_modal: {
        title: '批量添加论文日程',
        abstract_ids: '论文编号',
        please_input: '请输入',
        please_input_abstract_ids: '请输入论文编号',
        input_abstract_ids_tip: '请输入想要批量添加的论文编号，多条论文使用换行进行分隔',
        speaker_type: '讲题讲者类型',
        please_select_speaker_type: '请选择讲题讲者类型',
        speaker_type_cn: '中宾讲题讲者',
        speaker_type_en: '外宾讲题讲者',
        minutes: '每段日程任务的分钟数',
        please_input_minutes: '请输入每段日程任务的分钟数',
        reg: '例如：15',
        add_success: '添加成功'
    },
    import_program_details_drawer: {
        title: '日程导入详情',
        date: '日期',
        speaker: '讲者',
        time_range: '时段',
        venue: '会场',
        status: '状态',
        status_1: '已导入',
        save: '保存',
        name: '姓名',
        unit: '单位',
        phone: '电话',
        email: '邮箱',
        remark: '备注',
        abstract_title: '论文标题',
        abstract_id: '论文编号',
        abstract_type: '论文类别',
        duration: '时长',
        type: '发言类型',
        title: '题目',
        article_id: '文章ID号',
        checking: '校验中',
        check_data_integrity: '校验数据完整性',
        confirm_import: '确认导入',
        import: '导入中',
        reupload: '重新上传',
        deleted: '已删除',
        waiting_for_verification: '待校验',
        waiting_for_import: '待导入',
        importing: '导入中',
        import_success: '导入成功',
        import_failed: '导入失败',
        check_failed: '校验失败',
        new_import_task: '新增导入任务',
        upload_file: '上传文件',
        please_upload_file: '请上传导入数据',
        upload_data: '上传导入数据',
        upload_tips: '请上传后缀为xlsx的文件',
        download_template: '下载导入模板',
        download_instructions: '下载操作说明',
        add_success: '添加成功',
        limit_500: '文件大小不能超过500MB!',
        import_title: '日程导入',
        refresh: '刷新',
        add_import_task: '新增导入任务',
        view_details: '查看详情',
        task_id: '任务ID',
        task_status: '任务状态',
        create_time: '创建时间',
        update_time: '更新时间',
        actions: '操作'
    },
    search_user: {
        title: '搜索手机号/姓名：',
        placeholder: '手机号/姓名',
        please_input: '请输入',
        please_input_name: '请输入手机号/姓名',
        please_input_org_name: '单位名称（选填）',
        please_input_email: '请输入邮箱',
        search_btn: '搜索',
        task_num: '[有{ count }条任务]',
        attend_meeting: '[已参会] |',
        selected: '已选中',
        select: '选择',
        task_type: '任务类型',
        task_num: '任务数量',
        no_result: '如未查询到用户请点击',
        new: '新增',
        user_id: '用户ID',
        name: '汉字姓名',
        xing: '姓的拼音',
        please_input_xing: '请输入姓的拼音',
        ming: '名的拼音',
        please_input_ming: '请输入名的拼音',
        abbreviation: '姓名首字母简拼',
        please_input_abbreviation: '请输入姓名首字母简拼',
        reg: '用于讲者主持列表按照姓名拼音顺序排序时使用，请填写姓名首字母，比如姓名为王一一，则填写wyy。',
        country: '国家',
        region: '所属地区',
        org_cnname: '所在单位',
        please_input_org_cnname: '请输入所在单位',
        org_enname: '英文单位',
        please_input_org_enname: '请输入英文单位',
        department: '科室部门',
        please_input_department: '请输入科室部门',
        address: '通讯地址',
        please_input_address: '请输入通讯地址',
        phone: '手机号码',
        please_input_phone: '请输入手机号码',
        phone_format_error: '手机号码格式不正确',
        tel_no: '电话号码',
        zipcode: '邮政编码',
        please_input_zipcode: '请输入邮政编码',
        email: '电子邮箱',
        please_input_email: '请输入邮箱',
        org_cnname_d: '日程显示中文单位',
        org_enname_d: '日程显示英文单位',
        only_fill_when_different: '只有日程显示单位与用户单位不一致时填写，如果一致不需要填写',
        post_name: '职务',
        new_user_title: '新增用户',
        real_name: '姓名',
        please_input_real_name: '请输入姓名',
        org_cnname: '单位',
        member: '委员会',
        sequence: '届数',
        xzname: '任职机构',
        post: '职务',
        begin_time: '任职开始时间',
        end_time: '任职结束时间',
        date: '日期',
        hall: '会场',
        task: '任务',
        new_success: '新增成功',
        has_exist: '账号已存在,请勿重复添加',
        please_input_real_name: '请填写汉字姓名'
    },
    batch_add_program_by_abstract_ids: '根据论文编号批量添加日程',
    add_task_cn: '添加任务（中宾）',
    add_task_en: '添加任务（外宾）',
    add_sub_topic: '添加子讲题',
    delete_program: '确认删除该日程吗？',
    delete_task: '确认删除该任务吗？',
    import_program: '日程导入',
    changeProgram: '修改日程',
    session_info: 'Session信息',
    add_title: '添加讲题讲者',
    title_speaker: '讲题讲者',
    add_title_speaker_tips: '注意：修改日程时，直接修改题目会同时更改对应稿件标题，如需更换稿件请直接搜索。',
    cn_title: '中文标题',
    p_cn_title: '请输入中文标题',
    en_title: '英文标题',
    p_en_title: '请输入英文标题',
    fayan_type: '发言形式',
    p_fayan_type: '请选择发言形式',
    filter_paper: '可筛选论文',
    added: '已添加',
    not_added: '未添加',
    added_num: '已添加{num}次',
    paper_id: '讲题ID',
    paper_title: '标题',
    speaker: '讲者',
    unit: '单位',
    phone: '手机',
    no_query_paper: '如未查询到论文稿件信息请点击',
    new: '新增',
    wait_to_add: '待新增',
    child_session_management: '子日程管理'
};
